module.exports = __webpack_public_path__ + "static/media/background-map.d7e453c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Schools/assets/img/background-map.jpg
// module id = 1421
// module chunks = 0